module.exports = __webpack_public_path__ + "gm.f26ded8.png";